import React, { useRef, useState, useEffect } from "react";
import { Button } from "reactstrap";
import { useReactMediaRecorder } from "react-media-recorder";
import { stream } from "xlsx";

const MediaRecorder = ({
  closeTrigger = false,
  header = null,
  onRemoveUpload,
  onUpload,
  recordedVideoBlobUrlValue = null,
  interviewStatus,
}) => {
  const videoRef = useRef(null); // Reference for the live preview video element
  const [mediaStream, setMediaStream] = useState(null); // State to store the media stream
  const [isVideoRecorded, setIsVideoRecorded] = useState(false); // State to check if video is recorded
  const [isRecording, setIsRecording] = useState(false); // State to track if recording is ongoing

  const {
    status,
    startRecording,
    stopRecording,
    mediaBlobUrl,
    pauseRecording,
    resumeRecording,
    recordedVideoBlobUrl,
  } = useReactMediaRecorder({ video: true, audio: true });

  useEffect(() => {
    if (interviewStatus === "start" && mediaStream) {
      startRecording();
    }

    if (interviewStatus === "end") {
      handleStopRecording();
    }
  }, [interviewStatus, mediaStream]);

  // Function to start the video feed
  const startVideo = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        // video: true,
        video: {
          width: { ideal: 1920 }, // Full HD resolution
          height: { ideal: 1080 },
          frameRate: { ideal: 30 }, // Target 30fps
          facingMode: "user", // Use the front camera
        },
        audio: true,
      });
      setMediaStream(stream);
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
      }
    } catch (err) {
      console.error("Error accessing media devices.", err);
    }
  };

  // Function to stop the video feed
  const stopVideo = () => {
    if (mediaStream) {
      mediaStream.getTracks().forEach((track) => track.stop());
      setMediaStream(null); // Clear the media stream
    }
  };

  useEffect(() => {
    if (!recordedVideoBlobUrlValue) {
      startVideo();
    }
    return () => {
      stopVideo();
    };
  }, []);

  // useEffect to stop video when parent modal is closed
  useEffect(() => {
    if (closeTrigger) {
      stopRecording();
      stopVideo();
    }
  }, [closeTrigger, stopRecording]);

  // Handle start and stop recording with state updates
  const handleStartRecording = () => {
    startRecording();
    setIsRecording(true);
  };

  const handleStopRecording = () => {
    stopRecording();
    setIsRecording(false);
    setIsVideoRecorded(true);
    stopVideo();
  };

  // Remove video and reset to live stream
  const handleRemoveVideo = () => {
    setIsVideoRecorded(false);
    startVideo();
    onRemoveUpload();
  };

  return (
    <div>
      {header && <h2>{header}</h2>}
      <div className="mt-2">
        <h4 className="">
          Status:{" "}
          <span
            className="fw-bold"
            style={{
              color:
                status === "recording"
                  ? "red"
                  : status === "paused"
                  ? "blue"
                  : "green",
            }}
          >
            {status}
          </span>
        </h4>
      </div>

      <div>
        <div className="mb-3">
          {!isVideoRecorded && !recordedVideoBlobUrlValue ? (
            <video
              ref={videoRef}
              autoPlay
              muted
              style={{
                width: "100%",
                height: "auto",
                objectFit: "cover",
                borderRadius: "20px",
              }}
            />
          ) : (
            <>
              <h3>Playback</h3>
              <video
                src={recordedVideoBlobUrlValue || mediaBlobUrl}
                controls
                style={{
                  width: "100%",
                  height: "auto",
                  marginTop: "20px",
                  borderRadius: "20px",
                }}
              />
            </>
          )}
        </div>

        <div className="d-flex justify-content-center align-items-center gap-2">
          {/* {!isVideoRecorded ? ( */}
          {!isVideoRecorded && !recordedVideoBlobUrlValue ? (
            <>
              <Button type="button" onClick={handleStartRecording}>
                Start Recording
              </Button>
              <Button
                type="button"
                onClick={pauseRecording}
                disabled={status == "paused" || status == "idle"}
              >
                Pause Recording
              </Button>
              <Button
                type="button"
                onClick={resumeRecording}
                disabled={status == "recording" || status == "idle"}
              >
                Resume Recording
              </Button>
              <Button
                type="button"
                onClick={handleStopRecording}
                disabled={status == "idle"}
              >
                Stop Recording
              </Button>
            </>
          ) : (
            <>
              {!recordedVideoBlobUrlValue && (
                <Button type="button" onClick={() => onUpload(mediaBlobUrl)}>
                  Upload Video
                </Button>
              )}
              <Button type="button" onClick={handleRemoveVideo}>
                Remove Video
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default MediaRecorder;
